import createReactComponent from '../createReactComponent';
export default createReactComponent('tree', 'Tree', [["path",{"d":"M12 17h7l-4.5-6.5h3L12 3l-5.5 7.5h3L5 17zm0 0v4","key":"svg-0"}]]);